import React from 'react';
import { format } from 'date-fns';
import { ConflictInfo } from '../../types/schedule';

interface ConflictModalProps {
  isOpen: boolean;
  conflictInfo: ConflictInfo | null;
  onConfirm: () => void;
  onClose: () => void;
}

const ConflictModal: React.FC<ConflictModalProps> = ({
  isOpen,
  conflictInfo,
  onConfirm,
  onClose
}) => {
  if (!isOpen || !conflictInfo) return null;

  return (
    <div className="conflict-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h3>시간 충돌</h3>
          <button onClick={onClose} className="modal-close">
            ×
          </button>
        </div>
        <div className="modal-body">
          <p>선택하신 시간대에 다음과 같은 충돌이 발생했습니다:</p>
          <ul>
            {conflictInfo.conflictingEvents.map((event, index) => (
              <li key={index}>
                {event.title} ({format(new Date(event.start), 'HH:mm')}-{format(new Date(event.end), 'HH:mm')})
              </li>
            ))}
          </ul>
          <p>이 일정을 등록하시겠습니까?</p>
        </div>
        <div className="modal-footer">
          <button onClick={onConfirm} className="btn btn-primary">
            네, 등록합니다.
          </button>
          <button onClick={onClose} className="btn btn-white">
            아니오, 취소합니다.
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConflictModal;
